import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/*
  Public landing page for short-link redirects, e.g. /go/zoom.

  No auth required. Resolves the slug via the public backend endpoint and
  immediately replaces the location so the URL the user typed disappears
  from history (no double Back-button to get back here).

  We show a tiny "Redirecting…" UI for ~1s in case the network is slow OR
  the slug is broken — better than a blank page.
*/
export default function GoRedirect() {
  const { slug } = useParams();
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await axios.get(`${API}/go/resolve/${encodeURIComponent(slug || "")}`);
        const url = res.data?.url;
        if (!url) throw new Error("No url");
        if (alive) {
          // Replace so users hitting Back go to the page BEFORE the short link.
          window.location.replace(url);
        }
      } catch (e) {
        if (alive) {
          setError(
            e.response?.status === 404
              ? "This link isn't active anymore."
              : "Couldn't redirect — please try again in a moment."
          );
        }
      }
    })();
    return () => { alive = false; };
  }, [slug]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDF2F8] px-6">
      <div className="text-center max-w-sm">
        <div className="w-12 h-12 rounded-full bg-[#E91E8C]/10 mx-auto mb-4 flex items-center justify-center">
          <span className="text-2xl">→</span>
        </div>
        {error ? (
          <>
            <h1 className="text-lg font-bold text-zinc-900 mb-2">Hmm.</h1>
            <p className="text-sm text-zinc-600 mb-5">{error}</p>
            <a
              href="/"
              className="inline-block px-5 py-2.5 bg-[#E91E8C] text-white text-sm font-semibold rounded-lg hover:bg-[#c91a7b]"
            >
              Go to The Branding Bar
            </a>
          </>
        ) : (
          <>
            <h1 className="text-base font-semibold text-zinc-900 mb-1">Redirecting you…</h1>
            <p className="text-xs text-zinc-500">If nothing happens in a few seconds, refresh the page.</p>
          </>
        )}
      </div>
    </div>
  );
}
